import { intersection } from 'lodash';
import { useEffect, useState } from 'react';
import { ROW_TYPES } from 'components/base/Table/TableConsts';
import useGroupsTeam from '../../../hooks/useGroupTeams/useGroupTeams';
import { getTeamsTableRows } from './useTableRowsNew.service';

const useTableRowsNew = ({
  tableMetricsNames,
  availableMetricsWidgets,
  groupsManagedPages,
  aggregatedMetrics,
  metricsPerGranularity,
  aggregatedLastPeriodMetrics,
  metricsPerGranularityLastPeriod,
  lastPeriodDates,
  onLoadMoreClick,
  onExpandClick,
  isRowLoading,
  expandedTeamId
}) => {
  const [rows, setRows] = useState([]);

  const {
    orderedSelectedGroup,
    selectedGroupChildren,
    contributorsById,
    selectedGroupChildrenIds
  } = useGroupsTeam();

  const parseDataToRows = () => {
    const teamsTableRows = getTeamsTableRows({
      teams: selectedGroupChildren,
      metrics: aggregatedMetrics,
      availableMetricsWidgets,
      tableMetricsNames,
      metricsPerGranularity,
      aggregatedLastPeriodMetrics,
      metricsPerGranularityLastPeriod,
      lastPeriodDates,
      contributorsById,
      onLoadMoreClick,
      onExpandClick,
      groupsManagedPages,
      isRowLoading,
      expandedTeamId
    });

    const teamsIdsWithData = aggregatedMetrics.map(({ group }) => group);

    const selectedGroupsChildrenWithData = intersection(
      teamsIdsWithData,
      selectedGroupChildrenIds
    );

    if (
      selectedGroupsChildrenWithData.length < selectedGroupChildrenIds.length
    ) {
      teamsTableRows.push({
        rowType: ROW_TYPES.LOAD_MORE,
        childrenInView: selectedGroupsChildrenWithData.length,
        totalChildren: selectedGroupChildrenIds.length,
        onClick: () => onLoadMoreClick(orderedSelectedGroup)
      });
    }

    setRows(teamsTableRows);
  };

  useEffect(() => {
    parseDataToRows();
  }, [
    aggregatedMetrics,
    availableMetricsWidgets,
    tableMetricsNames,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    isRowLoading,
    expandedTeamId
  ]);

  return rows;
};

export default useTableRowsNew;
